module.exports = __webpack_public_path__ + "img/avatar5.2083ca7a.png";